import * as React from "react";
import { useLocation } from "react-router";
import { useSelector } from "react-redux";

import { TITLE_TEMPLATE_BATWORK } from "@config/consts";

import { DefaultLayout } from "@ui/Layouts";

import { useTranslate } from "@hooks/useTranslate";

import {
  Header,
  LoadingIndicator as Loading,
  FooterContainer,
} from "@work/containers";
import { getCountry } from "@work/redux/localisation/localisation.selectors";

interface Props {
  children: React.ReactNode;
}

const DefaultLayoutWork = (props: Props): React.ReactElement => {
  const location = useLocation();
  const translate = useTranslate();

  const country = useSelector(getCountry);

  return (
    <DefaultLayout
      country={country}
      title={translate("batwork_pwa_generic.meta_title")}
      titleTemplate={TITLE_TEMPLATE_BATWORK}
      header={<Header useNativeLinks={false} pathname={location.pathname} />}
      loading={<Loading />}
      footer={<FooterContainer />}
      somethingWentWrongText={translate(
        "batwork_pwa_generic.something_went_wrong",
      )}
      appCrashExplanationText={translate(
        "batwork_pwa_generic.app_crash_explanation",
      )}
    >
      {props.children}
    </DefaultLayout>
  );
};

DefaultLayoutWork.displayName = "DefaultLayoutWork";

export { DefaultLayoutWork };
